/* eslint-disable no-bitwise */
export const hexToRgbA = (hex: string, opacity?: number) => {
  let c: any;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');

    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + `,${opacity || 1})`;
  }

  console.warn(`Bad Hex: ${hex}`);
  return hex;
};

export const hexToGray = (hex: string) => {
  let c: any;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');

    const r = (c >> 16) & 255;
    const g = (c >> 8) & 255;
    const b = c & 255;

    const gray = Math.round(0.2126 * r + 0.7152 * g + 0.0722 * b);

    return `rgb(${gray},${gray},${gray})`;
  }

  console.warn(`Bad Hex: ${hex}`);
  return hex;
};

export const convertSVGColorCodeToGrayishRGB = (_colorIn: string): string => {
  const colorIn = _colorIn.toLowerCase();

  let RGB: {r: number | undefined; g: number | undefined; b: number | undefined};

  if (isColorHEX(colorIn)) {
    RGB = generateRGBFromHex(colorIn);
  } else if (isColorRGB(colorIn)) {
    RGB = generateRGBfromRGBString(colorIn);
  } else if (isColorInNamed(colorIn, NAMED_COLORS)) {
    return convertSVGColorCodeToGrayishRGB(NAMED_COLORS[colorIn]);
  } else {
    return '#000000';
  }
  const grayish = Math.round((RGB.r! + RGB.g! + RGB.b!) / 3);
  return `rgb(${grayish},${grayish},${grayish})`;
};

const NAMED_COLORS: Record<string, string> = {
  white: '#ffffff',
  black: '#000000',
  red: '#ff0000',
  green: '#00ff00',
  blue: '#0000ff',
  yellow: '#ffff00',
  cyan: '#00ffff',
  magenta: '#ff00ff',
  gray: '#808080',
};

function generateRGBFromHex(color: string) {
  const cleanHex = color.slice(1);
  const RGB: {r: number | undefined; g: number | undefined; b: number | undefined} = {r: 0, g: 0, b: 0};
  if (cleanHex.length === 3) {
    RGB.r = parseInt(cleanHex[0] + cleanHex[0], 16);
    RGB.g = parseInt(cleanHex[1] + cleanHex[1], 16);
    RGB.b = parseInt(cleanHex[2] + cleanHex[2], 16);
  } else {
    RGB.r = parseInt(cleanHex.slice(0, 2), 16);
    RGB.r = parseInt(cleanHex.slice(2, 4), 16);
    RGB.r = parseInt(cleanHex.slice(4, 6), 16);
  }
  return RGB;
}

function generateRGBfromRGBString(color: string) {
  const matches = color.match(/\d+/g);
  const RGB: {r: number | undefined; g: number | undefined; b: number | undefined} = {r: 0, g: 0, b: 0};
  if (matches) {
    RGB.r = parseInt(matches[0], 10);
    RGB.g = parseInt(matches[1], 10);
    RGB.b = parseInt(matches[2], 10);
  }
  return RGB;
}

function isColorInNamed(color: string, namedColors: Record<string, string>) {
  if (namedColors[color.toLowerCase()]) return true;
  return false;
}

function isColorHEX(color: string) {
  if (color.startsWith('#')) return true;
  return false;
}

function isColorRGB(color: string) {
  if (color.startsWith('rgb')) return true;
  return false;
}
